import {Token} from '@adsk/bim360-mc-interface';

export const getCurrentToken = docsURL =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const onError = () => {
      reject(xhr);
    };

    xhr.withCredentials = true;
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const parsedToken = Token.parse(JSON.parse(xhr.response));
        resolve(parsedToken);
      } else {
        onError();
      }
    };

    xhr.onerror = onError;
    xhr.ontimeout = onError;

    xhr.open('GET', `${docsURL}/session/token?validate_token=true`, true);
    xhr.send();
  });
